import { cloneDeep } from 'lodash';
import { AppBundle } from 'api/optimalprint-sdk.d';

type AbstractProductAttribute =
  AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.ProductItem.IAttribute;

const setAttributeValue = (attributesOriginal: AbstractProductAttribute[], typeName: string, value: string) => {
  const attributes = cloneDeep(attributesOriginal);
  const targetAttribute = attributes.find((attr) => attr.typeName === typeName);
  if (targetAttribute) {
    targetAttribute.value = value;
  } else {
    attributes.push({
      typeName,
      value,
    });
  }
  return attributes;
};

export default setAttributeValue;
